module.exports = __webpack_public_path__ + "img/google.f39269e.png";